import { DateTime } from "luxon";
import { assertIsDateTimeValid } from "./assertIsDateTimeValid";

export const AWS_DATE_FORMAT = "yyyy-MM-ddZZ";

export function createDateTimeFromAwsDate(
  awsDate: string,
  contextName: string
): DateTime {
  const result = DateTime.fromFormat(awsDate, AWS_DATE_FORMAT);

  assertIsDateTimeValid(result, contextName);

  return result;
}

export function createAwsDateFromDateTime(awsDate: DateTime): string {
  assertIsDateTimeValid(awsDate, "awsDate");

  return awsDate.toFormat(AWS_DATE_FORMAT);
}
